import {createSelector} from '@reduxjs/toolkit';
import {RootState} from '../store';
import {PendingTranscription} from '../../lib/pendingTranscriptions';

/** Jobs held until the session budget resets. See `pendingTranscriptionsSlice`. */
export const pendingTranscriptionsSelector = (state: RootState) => state.pendingTranscriptions.data;

/** Keyed for the workspace join — one queued job per audio file, by construction. */
export const pendingByAudioIdSelector = createSelector(
  [pendingTranscriptionsSelector],
  (pending): Map<string, PendingTranscription> =>
    new Map(pending.map(entry => [entry.audioId, entry]))
);

/**
 * The earliest release still in the future, or null.
 *
 * Only used to decide whether anything is worth ticking for — the runner re-reads the clock itself
 * rather than trusting a selector's snapshot of "now".
 */
export const nextPendingReleaseSelector = createSelector(
  [pendingTranscriptionsSelector],
  (pending): string | null => {
    if (pending.length === 0) {
      return null;
    }

    return pending
      .map(entry => entry.releaseAt)
      .sort()[0] ?? null;
  }
);
